module.exports = __webpack_public_path__ + "static/4.2_early_empires-fa8fa65b6d16383519e9bb0760e4325b.pdf";